export default {
  // general
  support_risks: 'Risks',
  'support_risks.singular': 'Risk',

  // list
  'support_risks.list.description': 'Detected Risks content manager',
  'support_risks.list.empty_text': 'No Risks Found',
  'support_risks.list.create_new_text': '+ New Risk',
  'support_risks.list.header.doc': 'Document',

  // delete
  'support_risks.list.delete.success': 'Successfully deleted Risk {{name}}',
  'support_risks.list.delete.error':
    'There was a problem while removing the Risk. Please try again.',

  // delete modal
  'support_risks.list.delete.modal.title': 'Delete Risk?',
  'support_risks.list.delete.modal.text':
    'Are you sure you want to delete Risk "{{name}}"? This action can\'t be undone.',

  // disable/enable
  'support_risks.disable': 'Disable',
  'support_risks.disabled': 'Disabled',
  'support_risks.enable': 'Enable',
  'support_risks.enabled': 'Enabled',

  // disable/enable modal
  'support_risks.list.disable.modal.text':
    'Are you sure you want to disable "{{name}}"? (It will not be deleted)',
  'support_risks.list.disable.modal.title': 'Disable Risk?',
  'support_risks.list.enable.modal.title': 'Enable Risk?',

  // risk evaluation
  'support_risks.risk_evaluation.title': 'Risk Evaluation',
  'support_risks.risk_evaluation.button_text': 'Evaluate Risk',
  'support_risks.risk_evaluation.form.service_id.label':
    'Service ID (optional)',
  'support_risks.risk_evaluation.form.team_id.label': 'Team ID (optional)',

  // general
  'support_risks.successfully': 'Successfully',

  // general errors
  'support_risks.errors.failed_action':
    'A problem occurred while taking action',
  'support_risks.errors.try_again': 'Please try again.'
}
